<template>
  <div
    class="sf-tab sf-tab-full sf-pointer rs-active-filters-list sf-bg-snow"
    data-testid="active-filters-list"
  >
    <div
      v-for="filter in filters"
      :key="filter.key"
      :data-filter-type="filter.type"
      class="sf-tab-item sf-c-text-darker sf-pad-0 sf-below-1 sf-hover"
      data-testid="active-filter"
      @click="editFilter(filter)"
    >
      <div class="sf-level sf-level-between sf-pad-1">
        <div class="sf-level-item tw-overflow-hidden">
          <div>{{ filterName(filter) }}</div>
          <div
            v-if="!filterDropdownValuesLoading"
            class="sf-font-light tw-truncate"
          >
            {{ activeFilterSubtitle(filter) }}
          </div>
        </div>
        <div class="sf-level-item tw-min-w-9 tw-text-right">
          <i
            v-if="!immutable"
            data-testid="remove-filter"
            class="
              fa fa-regular fa-trash-can
              sf-c-text-highlight sf-bg-snow sf-hover-item sf-dim-el-hover
            "
            @click.stop.prevent="removeFilter(filter)"
          ></i>
          <i
            v-if="hasError(filter)"
            v-tooltip="
              I18n.t('companies_overview.filters.filter_error_tooltip', {
                count: errorCount(filter),
              })
            "
            class="
              fa fa-solid fa-triangle-exclamation
              tw-pl-2 tw-text-sf-danger-dark
            "
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import readableColumnName from '../../utils/readable-column-name'

export default {
  props: {
    editFilter: {
      type: Function,
      required: true,
    },

    immutable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapState({
      filters: (state, getters) =>
        getters.getActiveFilters.map((filter) => ({
          ...filter,
          ...state.filters.allFiltersByType[filter.type],
          key: [filter.name_key, filter.uuid].join('_'),
        })),
      filterDropdownValuesLoading: (state) =>
        state.filters.filterDropdownValuesLoading,
    }),

    ...mapGetters(['activeFilterSubtitle', 'errorCountsPerFilter']),
  },

  methods: {
    ...mapActions({
      removeFilter: 'removeActiveFilter',
    }),

    filterName(filter) {
      const { columnName } = filter
      return readableColumnName(columnName, filter.name_key)
    },
    errorCount(filter) {
      return this.errorCountsPerFilter[filter.uuid] || 0
    },
    hasError(filter) {
      return this.errorCount(filter) > 0
    },
  },
}
</script>
